import { render } from "./App.vue?vue&type=template&id=2c27a7b6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2c27a7b6&lang=less"

import exportComponent from "E:\\永福丽项目\\永富丽官网Vue3\\app_winfully_cn\\app_qy_vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__